<template>
  <NoWishList
    v-if="!showableWishListPage"
    :is-personal-use="isPersonalUse"
    :order-id="orderId"
    :order-code="orderCode"
    :gift-url="giftUrl"
    :my-page-order-histories-path="myPageOrderHistoriesPath"
    :my-page-gifts-path="myPageGiftsPath"
    :is-app="isApp"
    :order-histories-deep-link="orderHistoriesDeepLink"
    :gift-card-id="giftCardId"
  />
  <FromWishList
    v-else
    :showable-wish-list-user="showableWishListUser"
    :wish-list-user-nick-name="wishListUserNickName"
    :profile-path="wishListUserProfilePath"
    :wish-list-user-icon-image-path="wishListUserIconImagePath"
    :gift-url="giftUrl"
    :order-code="orderCode"
    :is-app="isApp"
    :order-histories-deep-link="orderHistoriesDeepLink"
  />
</template>

<script>
import NoWishList from '../../organism/orders/NoWitsList.vue'
import FromWishList from '../../organism/orders/FromWishList.vue'

export default {
  components: {
    FromWishList,
    NoWishList
  },
  props: {
    isPersonalUse: {
      type: Boolean,
      required: false
    },
    myPageGiftsPath: {
      type: String,
      required: true
    },
    myPageOrderHistoriesPath: {
      type: String,
      required: true
    },
    giftUrl: {
      type: String,
      required: true
    },
    orderId: {
      type: Number,
      required: true
    },
    orderCode: {
      type: String,
      required: true
    },
    showableWishListPage: {
      type: Boolean,
      required: false,
      default: false
    },
    showableWishListUser: {
      type: Boolean,
      required: false,
      default: false
    },
    wishListUserNickName: {
      type: String,
      required: false,
      default: ''
    },
    wishListUserProfilePath: {
      type: String,
      required: false,
      default: ''
    },
    wishListUserIconImagePath: {
      type: String,
      required: false,
      default: ''
    },
    isApp: {
      type: Boolean,
      required: false,
      default: false
    },
    orderHistoriesDeepLink: {
      type: String,
      required: true
    },
    giftCardId: {
      type: Number,
      required: true
    }
  },
  data() {},
  mounted() {},
  methods: {}
}
</script>
